/**
 * Created by Bart Decorte.
 * Date: 06/10/2018
 * Time: 15:47
 */

export default class ColorPicker {
  constructor(root) {
    this.root = root;
    this.colorInput = this.root.querySelector('.js-column-color');
    this.valueInput = this.root.querySelector('.js-column-value');
    this.textualInput = this.root.querySelector('.js-column-textual');
    this.preview = this.root.querySelector('.js-preview');
    this.bindListeners();
  }

  bindListeners() {
    this.textualInput.addEventListener('focusin', () => {
      this.lTextInputFocusIn();
    });
    this.textualInput.addEventListener('input', () => {
      this.lTextInputInput();
    });
    this.textualInput.addEventListener('focusout', () => {
      this.lTextInputFocusOut();
    });
    this.colorInput.addEventListener('input', () => {
      this.lColorInputInput();
    });
    ('#ffffff');
  }

  lTextInputFocusIn() {
    this.colorInput.dispatchEvent(new MouseEvent('click'));
    // this.textualInput.dispatchEvent(new FocusEvent('blur'));
    this.colorInput.blur();
  }

  lTextInputInput() {
    let input = this.textualInput.value;

    const pattern = /#?([0-9a-fA-F]{6}).*/;
    if (pattern.test(input)) {
      input = input.replace(pattern, '#$1');
      this.colorInput.value = input;
      this.valueInput.value = input;
      this.updatePreview(input);
    }

    if (!input.length) {
      this.colorInput.removeAttribute('value');
      this.valueInput.value = '';
      this.updatePreview(input);
    }
  }

  lTextInputFocusOut() {
    const value = this.valueInput.value;
    this.textualInput.value = value ? value.substring(1) : '';
  }

  lColorInputInput() {
    const value = this.colorInput.value;
    this.textualInput.value = value.substring(1);
    this.valueInput.value = value;
    this.updatePreview(value);
  }

  updatePreview(hex) {
    this.preview.style.backgroundColor = hex ? hex : '';
    this.preview.style.color = hex ? this.invertColor(hex) : '';
    return this;
  }

  invertColor(hex) {
    let value = hex.substring(1); // Loose the '#'
    let components = [];
    for (let i = 0; i < 6; i += 2) {
      components.push(value.substr(i, 2)); // Split into pairs
    }
    components = components.map((component) => {
      return (255 - parseInt(component, 16)).toString(16).padStart(2, '0');
    });
    return `#${components.join('')}`; //
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utils/ColorPicker.js